import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "./motion";

const BASE = "https://static.prod-images.emergentagent.com/jobs/dd7b4901-0aa8-42e0-9fa7-305e497a1e26/images/";
const BEFORE = `${BASE}6cdfc8965b575524029269ee6dadf11ac93c52ab25e938e3da14c605d2e0f954.jpeg`;
const AFTER = `${BASE}8a9dda40b48e73120f50df513084ac07eac57d75326493c70f4890c9e1bb919a.jpeg`;

export const BeforeAfter = () => {
  const [pos, setPos] = useState(50);
  const box = useRef(null);
  const drag = useRef(false);

  const move = (e) => {
    if (!drag.current) return;
    const r = box.current.getBoundingClientRect();
    setPos(Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100)));
  };
  const start = (e) => {
    drag.current = true;
    e.currentTarget.setPointerCapture(e.pointerId);
    move(e);
  };

  return (
    <section id="results" className="relative py-24 md:py-32" data-testid="before-after-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12">
          <div>
            <Eyebrow>The difference</Eyebrow>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1]">
              <MaskLines lines={["From spaghetti", <span className="font-serif-i font-normal text-cyan-300">to standards.</span>]} />
            </h2>
          </div>
          <Reveal><p className="max-w-sm text-slate-400">Drag the slider. Same cabinet, before and after a Lunar install — labelled, patched, powered and documented.</p></Reveal>
        </div>
        <Reveal>
          <div
            ref={box}
            onPointerDown={start}
            onPointerMove={move}
            onPointerUp={() => (drag.current = false)}
            onPointerCancel={() => (drag.current = false)}
            className="chamfer relative aspect-[4/3] sm:aspect-[16/9] w-full select-none overflow-hidden border border-white/10 cursor-ew-resize touch-pan-y"
            data-testid="before-after-slider"
          >
            <img src={AFTER} alt="Tidy comms rack after a Lunar install" className="absolute inset-0 h-full w-full object-cover" draggable="false" />
            <img src={BEFORE} alt="Messy comms cabinet before" className="absolute inset-0 h-full w-full object-cover" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} draggable="false" />
            <span className="absolute left-4 top-4 rounded-full bg-rose-500/90 px-3 py-1 font-mono text-[10px] tracking-[0.2em] text-white" style={{ opacity: pos > 12 ? 1 : 0 }}>BEFORE</span>
            <span className="absolute right-4 top-4 rounded-full bg-cyan-300 px-3 py-1 font-mono text-[10px] tracking-[0.2em] text-void" style={{ opacity: pos < 88 ? 1 : 0 }}>AFTER · LUNAR</span>
            <div className="absolute inset-y-0 w-px bg-cyan-300 shadow-[0_0_20px_#00F0FF]" style={{ left: `${pos}%` }}>
              <span className="absolute left-1/2 top-1/2 grid h-12 w-12 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full border border-cyan-300 bg-void/80 text-cyan-300 backdrop-blur" data-testid="before-after-handle">
                <MoveHorizontal size={20} />
              </span>
            </div>
            <input type="range" min="0" max="100" value={Math.round(pos)} onChange={(e) => setPos(+e.target.value)} aria-label="Before and after comparison" className="sr-only" data-testid="before-after-range" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
